import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Updates } from '../../components/updates/updates';
import { PublicSecurity } from '../../components/public-security/public-security';
import { PrivateSecurity } from '../../components/private-security/private-security';
import { Inspections } from '../../components/inspections/inspections';
import { ContactFormCompact } from '../../components/contact-form-compact/contact-form-compact';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-main',
  imports: [Updates, PublicSecurity, PrivateSecurity, Inspections, ContactFormCompact, FontAwesomeModule],
  templateUrl: './main.html',
  styleUrl: './main.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class Main {

}
